import { Slide, toast, ToastOptions } from 'react-toastify';

const AUTO_CLOSE_MS = 4000;

export type NotificationMode = 'info' | 'success' | 'error';

/** Show a sliding, wave-branded notification (see .wm-toast in index.css). */
export function showNotification(message: string, mode: NotificationMode) {
    const notificationOptions: ToastOptions = {
        autoClose: AUTO_CLOSE_MS,
        hideProgressBar: true,
        position: 'bottom-center',
        className: `wm-toast wm-toast--${mode}`,
        transition: Slide,
    };

    toast[mode](message, notificationOptions);
}
